import { ChevronDownIcon } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import SimpleDropdown from 'src/shared/components/ui/popups/dropdown-menu/simple-dropdown'
import { cn } from 'src/shared/utils/cn'

interface HeaderDropdownProps {
  theme?: 'light' | 'dark'
  title: string
}

export default function HeaderDropdown({ theme = 'dark', title }: HeaderDropdownProps) {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const forHomeownersOnClick = () => {
    navigate(paths.root.getHref())
  }

  const forProfessionalsOnClick = () => {
    navigate(paths.professionals.index.getHref())
  }

  const forCompaniesOnClick = () => {
    navigate(paths.enterprise.getHref())
  }

  return (
    <SimpleDropdown
      trigger={
        <button
          className={cn(
            'flex flex-row items-center gap-1 p-2 text-[14px] text-muted',
            theme === 'light' && 'text-white',
          )}
        >
          {title} <ChevronDownIcon size={16} className={cn(isOpen && 'rotate-180')} />
        </button>
      }
      onOpenChange={setIsOpen}
      items={[
        { label: 'For homeowners', onClick: forHomeownersOnClick },
        {
          label: 'For agents & LOs',
          onClick: forProfessionalsOnClick,
        },
        {
          label: 'For companies',
          onClick: forCompaniesOnClick,
        },
      ]}
    />
  )
}
